<script lang="ts">
  import { Button, Col, Container, Row } from "sveltestrap";
  import BookmarkAddPost from "./BookmarkAddPost.svelte";
  import Card from "../../../Core/Card.svelte";
  import { Discard, Post } from "../../../../utils/Constant/Constant";
  import BlogPostForm from "./BlogPostForm.svelte";
  import AddPostForm from "./AddPostForm.svelte";
</script>
<BookmarkAddPost />
<Container fluid={true}>
  <Row>
    <Col sm="12">
      <Card headerTitle="Post Edit" cardHeaderprops="pb-0" cardBodyprops="add-post">
        <div slot="contentbody"  class="add-post">
          <BlogPostForm />
          <AddPostForm />
          <div class="btn-showcase">
            <Button color="primary" type="submit">{Post}</Button>
            <Button color="light" type="reset">{Discard}</Button>
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</Container>